import { render, staticRenderFns } from "./SVG-ShoreditchBldgs.vue?vue&type=template&id=4375cc07&"
import script from "./SVG-ShoreditchBldgs.vue?vue&type=script&lang=js&"
export * from "./SVG-ShoreditchBldgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports